<template>
    <div class="announcement">
        <div class="announcement__text">
            <template v-for="(item, index) in announcementText">
                    <span v-if="index != 0">|</span>
                    <a :href="formatUrl(item.url)">
                        {{ item.text }}
                    </a>
            </template>
        </div>
        <div class="announcement__image">
            <template v-for="item in announcementImage">
                <a :href="formatUrl(item.url)">
                    <img :src="'//img.souche.com/' + item.image" :title="item.text" :alt="item.text">
                </a>
            </template>
        </div>
        <div class="other">
            <a href="/?__mobile=true">进入手机版</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['arg0'],
        computed: {
            announcementText: function () {
                var ret = [];
                this.arg0.forEach(function (v) {
                    if (!v.image) {
                        ret.push(v);
                    }
                });
                return ret;
            },
            announcementImage: function () {
                var ret = [];
                this.arg0.forEach(function (v) {
                    if (v.image) {
                        ret.push(v);
                    }
                });
                return ret;
            }
        },
        methods: {
            formatUrl(url) {
                if (!url) {
                    return false;
                }
                if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0 && url.indexOf('/') !== 0) {
                    url = `//${url}`;
                }
                return url;
            }
        }
    };
</script>

<style lang="less" scoped>
    .announcement {
        padding-top: 8px; 
        height: 162px;
        border-top: #4a4a4a 1px solid;
        .announcement__text {
            span {
                color: #bbb;
                font-size: 12px;
            }
            a {
                color: #bbb;
                font-size: 12px;
                text-decoration: none;
            }
        }
        .announcement__image {
            margin-top: 8px;
            height: 32px;
            img {
                height: 100%;
                margin-right: 16px;
            }
        }
        .other {
            position: absolute;
            bottom: 20px;
            right: 0;
            a {
                color: #bbb;
                font-size: 14px;
                text-decoration: none;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Announcement.vue?17e46728